import dlfprivanawest from "../../../../public/projects/DLF/images/projects/dlfprivanawest.webp";
import dlfprivananorth from "../../../../public/projects/DLF/images/projects/dlfprivananorth.webp";
import dlfprivanasouth from "../../../../public/projects/DLF/images/projects/dlfprivanasouth.webp";
import thearbour from "../../../../public/projects/DLF/images/projects/dlfthearbour.webp";
import dahilas from "../../../../public/projects/DLF/images/projects/dlfdahlias.webp";
import andheri from "../../../../public/projects/DLF/images/projects/andheri.jpg";
import logo from "../../../../public/projects/DLF/images/logo/logo.png";

//Privana West
import overviewImage_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/Overview/1.webp";
import bannerDesktopImage_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/Banner/1.webp";
import bannerMobileImage_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/Banner/2.webp";
import siteVisitBannerImage_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/SiteVisitBanner/1.webp";
import Location_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/Location/L1.webp";
import Hightlights_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/Highlights/1.webp";
import image1BHK_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/floorplan/1.webp";
import location_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/Overview/l.png";
import cal_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/Overview/c.png";
import newlaunch_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/Overview/n.png";
import g1_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/Gallery/1.webp";
import g2_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/Gallery/2.webp";
import g3_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/Gallery/3.webp";
import g4_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/Gallery/4.webp";
import g5_privana_west from "../../../../public/projects/DLF/images/Gurugram/privana_west/Gallery/5.webp";

//DLF The Arbour
import overviewImage_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/Overview/1.webp";
import bannerDesktopImage_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/Banner/1.webp";
import bannerMobileImage_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/Banner/2.webp";
import siteVisitBannerImage_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/SiteVisitBanner/1.webp";
import Location_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/Location/L1.webp";
import Hightlights_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/Highlights/1.webp";
import image1BHK_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/floorplan/1.webp";
import location_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/Overview/l.png";
import cal_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/Overview/c.png";
import newlaunch_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/Overview/n.png";
import g1_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/Gallery/1.webp";
import g2_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/Gallery/2.webp";
import g3_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/Gallery/3.webp";
import g4_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/Gallery/4.webp";
import g5_the_arbour from "../../../../public/projects/DLF/images/Gurugram/the_arbour/Gallery/5.webp";

//Dahlias
import overviewImage_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/Overview/1.webp";
import bannerDesktopImage_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/Banner/1.webp";
import bannerMobileImage_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/Banner/2.webp";
import siteVisitBannerImage_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/SiteVisitBanner/1.webp";
import Location_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/Location/L1.webp";
import Hightlights_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/Highlights/1.webp";
import image1BHK_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/floorplan/1.webp";
import image2BHK_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/floorplan/2.webp";
import location_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/Overview/l.png";
import cal_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/Overview/c.png";
import newlaunch_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/Overview/n.png";
import g1_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/Gallery/1.webp";
import g2_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/Gallery/2.webp";
import g3_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/Gallery/3.webp";
import g4_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/Gallery/4.webp";
import g5_dahlias from "../../../../public/projects/DLF/images/Gurugram/dahlias/Gallery/5.webp";

//Privana south
import overviewImage_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/Overview/1.webp";
import bannerDesktopImage_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/Banner/1.webp";
import bannerMobileImage_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/Banner/2.webp";
import siteVisitBannerImage_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/SiteVisitBanner/1.webp";
import Location_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/Location/L1.webp";
import Hightlights_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/Highlights/1.webp";
import image1BHK_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/floorplan/1.webp";
import location_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/Overview/l.png";
import cal_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/Overview/c.png";
import newlaunch_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/Overview/n.png";
import g1_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/Gallery/1.webp";
import g2_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/Gallery/2.webp";
import g3_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/Gallery/3.webp";
import g4_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/Gallery/4.webp";
import g5_privana_south from "../../../../public/projects/DLF/images/Gurugram/privana_south/Gallery/5.webp";

// privananorth
import overviewImageprivananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/overview/1.webp";
import bannerDesktopImageprivananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/banner/1.webp";
import bannerMobileImageprivananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/banner/2.webp";
import Locationprivananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/location/1.webp";
import Hightlightsprivananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/highlights/1.webp";
import floorplan1privananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/floorplan/1.webp";
import floorplan2privananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/floorplan/2.webp";
import floorplan3privananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/floorplan/3.webp";
import locationiconprivananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/overview/l.png";
import caliconprivananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/overview/c.png";
import newlaunchiconprivananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/overview/n.png";
import gallery1privananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/gallery/1.webp";
import gallery2privananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/gallery/2.webp";
import gallery3privananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/gallery/3.webp";
import gallery4privananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/gallery/4.webp";
import gallery5privananorth from "../../../../public/projects/DLF/images/Gurugram/privananorth/gallery/5.webp";

export const headerData = {
  logo: logo,
  data: {
    experience: `1946`,
    projects: `200`,
    ongoingprojects: `20`,
  },
  about: `DLF is one of India's largest and most prominent real
      estate developers. Known for its landmark residential, commercial, and retail projects,
       DLF emphasizes quality, innovation, and sustainability. With a strong presence across major
        cities, DLF offers luxury living spaces and state-of-the-art business environments.`,
};

export const developersDLF = {
  properties: [
    {
      name: "DLF - Privana west",
      image: dlfprivanawest,
      price: " 7.5 Cr",
      location: "Sector 76, Gurugram",
      state: "Gurugram",
      projectlocation: "Southern Peripheral Road",
      developer: "DLF",
      bed: "4 BHK",
      size: "3577 sq.ft",
      url: `/dlf-privana-west-sector-76-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "DLF - Privana west", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "DLF - Privana South",
      image: dlfprivanasouth,
      price: " 7.5 Cr",
      location: "Sector 77, Gurugram",
      developer: "DLF",
      projectlocation: "Central Peripheral Road",
      state: "Gurugram",
      bed: "4 BHK",
      size: "2150 sq. ft.",
      url: `/dlf-privana-south-sector-77-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "DLF - Privana South", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "DLF - Dahlias",
      image: dahilas,
      price: "On Request",
      location: "Sector 54, Gurugram",
      state: "Gurugram",
      projectlocation: "Golf Course Road",
      developer: "DLF",

      bed: "4 - 5 BHK",
      size: "....",
      url: `/dlf-dahlias-sector-54-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "DLF - Dahlias", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "DLF - The Arbour",
      image: thearbour,
      price: " 8.17 Cr",
      location: "Sector 63, Gurugram",
      developer: "DLF",
      projectlocation: "Golf Course Extension Road",
      state: "Gurugram",
      bed: " 4 BHK",
      size: "3800 sq. ft.",
      url: `/dlf-arbour-sector-63-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "DLF - The Arbour", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "DLF - Andheri",
      image: andheri,
      price: "On Request",
      developer: "DLF",
      location: "Andheri West",
      projectlocation: "Andheri West",
      state: "Mumbai",
      bed: "2 - 4 BHK",
      size: "On Request",
      url: ``,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
  ],
};
export const projectsDLF = {
  dlfprivanasouth: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_privana_south,
      bannerMobileImage: bannerMobileImage_privana_south,
      textOverlay: "",
      data: {
        title: "DLF Privana South",
        rerano: "HARERA/GGM/772/504",
        starting_price: "₹ 7.5 Cr",
        payment_plan: "CLP",
        status: "Under Construction",
        subtitle: "Sector 77, gurugram",
      },
    },
    overview: {
      heading: "Discover Luxury Living at DLF Privana South",
      description: [
        `DLF Privana South is a residential development by DLF Homes situated in Sector 77, gurugram.

The project offers 4BHK Apartments and Penthouse with perfect combination of contemporary architecture and features to provide comfortable living`,
        `This project is spanned across a wide area and natural beauty with 88% green coverage. All of this is situated in a
     convenient and friendly neighborhood with outstanding amenities. They aim to provide you with comfort and beauty by serving all 
     your needs.They offers a perfect blend of convenience and serenity.`,
      ],
      image: overviewImage_privana_south,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_privana_south,
          title: "₹ 7.5 Cr",
          subtitle: "Starting price",
        },
        {
          iconClass: cal_privana_south,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_privana_south,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_privana_south,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "4 BHK",
          area: "2150 sq. ft.",
          price: " 7.5 Cr",
        },
      ],
    },

    floor_plan: [
      {
        type: "4 BHK",
        area: "2150 sq. ft.",
        price: " 7.5 Cr",
        image: image1BHK_privana_south,
      },
    ],

    highlights: {
      images: Hightlights_privana_south,
      tagline: "Highlights",
      features: [
        "5 Towers, 63 units per acre",
        "80% Open Space",
        "3 Car Parks - Typical Units",
        "View of the Aravalli Hills",
      ],
    },

    location: {
      image: Location_privana_south,
      data: [
        {
          airport: {
            distance_time: "29.9 kms",
            name: "IGI Airport"
          },
          school: {
            distance_time: "5.3 Kms",
            name: "Vega School"
          },
          railwayormetro: {
            distance_time: "17.2 Kms",
            name: "Garhi Junction"
          },
          hospital: {
            distance_time: "2 Kms",
            name: " MET Hospital"
          },
          mall: {
            distance_time: "3.3 Kms",
            name: "Entertainland Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_privana_south },
        { image: g2_privana_south },
        { image: g3_privana_south },
        { image: g4_privana_south },
        { image: g5_privana_south },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in DLF Privana South, kindly share more details.",
    },

    faq: [

      {
        question: "Where is DLF Privana South located?",
        answer: `The project is situated in Sector 77, gurugram, with excellent connectivity to NH-48, Southern Peripheral Road, and key business hubs.`,
      },
      {
        question: "What types of residences are available in DLF Privana South?",
        answer: `DLF Privana South offers spacious 4 BHK luxury apartments with modern architecture and premium fittings.`,
      },
      {
        question: "What are the key amenities at DLF Privana South?",
        answer: `The project includes a clubhouse, swimming pool, gym, landscaped gardens, kids' play areas, jogging tracks, and 24/7 security.`,
      },
      {
        question: "What is the starting price of apartments in DLF Privana South?",
        answer: `Pricing details are available upon request and may vary based on the apartment size and configurations.`,
      },
      {
        question: "Is DLF Privana South RERA registered?",
        answer: `Yes, the project is RERA-approved, ensuring compliance with government regulations.`,
      },
      {
        question: "What makes DLF Privana South a standout choice for homebuyers?",
        answer: `DLF Privana South in Sector 77, gurugram, stands out as a premier residential choice for homebuyers due to its blend of luxury, exclusivity, and modern conveniences.`,
      },
      {
        question: "What is the total area of DLF Privana South?",
        answer: `The project is spread over a vast area, designed to offer a blend of luxury and green open spaces.`,
      },
      {
        question: "How well is DLF Privana South connected to key areas in gurugram?",
        answer: `It enjoys seamless connectivity to Cyber City, Sohna Road, IGI Airport, and key commercial and residential hubs.`,
      },
      {
        question: "Are there reputed schools and hospitals near DLF Privana South?",
        answer: `Yes, top schools like DPS and Heritage School and hospitals like Medanta and Artemis are in close proximity.`,
      },
      {
        question: "Why should one invest in DLF Privana South?",
        answer: `With DLF’s brand reputation, strategic location, premium design, and high-end amenities, it offers excellent investment potential.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "DLF - Privana west",
          image: dlfprivanawest,
          price: " 7.5 Cr",
          location: "Sector 76, Gurugram",
          state: "Gurugram",
          projectlocation: "Southern Peripheral Road",
          developer: "DLF",
          bed: "4 BHK",
          size: "3577 sq.ft",
          url: `/dlf-privana-west-sector-76-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - Privana west", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - Privana South",
          image: dlfprivanasouth,
          price: " 7.5 Cr",
          location: "Sector 77, Gurugram",
          developer: "DLF",
          projectlocation: "Central Peripheral Road",
          state: "Gurugram",
          bed: "4 BHK",
          size: "2150 sq. ft.",
          url: `/dlf-privana-south-sector-77-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - Privana South", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - Dahlias",
          image: dahilas,
          price: "On Request",
          location: "Sector 54, Gurugram",
          state: "Gurugram",
          projectlocation: "Golf Course Road",
          developer: "DLF",

          bed: "4 - 5 BHK",
          size: "....",
          url: `/dlf-dahlias-sector-54-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - Dahlias", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - The Arbour",
          image: thearbour,
          price: " 8.17 Cr",
          location: "Sector 63, Gurugram",
          developer: "DLF",
          projectlocation: "Golf Course Extension Road",
          state: "Gurugram",
          bed: " 4 BHK",
          size: "3800 sq. ft.",
          url: `/dlf-arbour-sector-63-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - The Arbour", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - Andheri",
          image: andheri,
          price: "On Request",
          developer: "DLF",
          location: "Andheri West",
          projectlocation: "Andheri West",
          state: "Mumbai",
          bed: "2 - 4 BHK",
          size: "On Request",
          url: ``,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },

  dlfprivanawest: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_privana_west,
      bannerMobileImage: bannerMobileImage_privana_west,
      textOverlay: "",
      data: {
        title: "DLF Privana West",
        rerano: "GGM/819/551/2024/46",
        starting_price: "₹ 7.24 Cr",
        payment_plan: "CLP",
        status: "Under Construction",
        subtitle: "Sector 76, Gurugram",
      },
    },
    overview: {
      heading: "Discover Luxury Living at DLF Privana West",
      description: [
        `DLF Privana West Introducing the new lifestyle where you are associated with a green backdrop each day, every footfall of the way. 
       The project is spread across 115 acres in sector 76 and 77, Gurugram. DLF Privana West is situated against the grand green Aravalli 
       Hills with 88% green coverage; these high-rise homes make up an integrated township in the heart of Gurugram but are at the same time
        far from the uproar of the metropolitan countryside. Provides connectivity to NH-8, Dwarka Expressway and SPR.The project currently
         offers 4 BHK Apartments with study and servant quarters.`,
      ],
      image: overviewImage_privana_west,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_privana_west,
          title: "₹ 7.24 Cr ",
          subtitle: "Starting price",
        },
        {
          iconClass: cal_privana_west,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_privana_west,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_privana_west,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "4 BHK",
          area: "3577 sq.ft",
          price: " 7.5 Cr",
        },
      ],
    },

    floor_plan: [
      {
        type: "4 BHK",
        area: "3577 sq.ft",
        price: " 7.5 Cr",
        image: image1BHK_privana_west,
      },
    ],

    highlights: {
      images: Hightlights_privana_west,
      tagline: "Highlights",
      features: [
        "500 mtr wide reserved greens",
        "24 m wide circulation road",
        "80% Open Space",
        "5 Towers, 63 units per acre",
      ],
    },

    location: {
      image: Location_privana_west,
      data: [
        {
          airport: {
            distance_time: "27.4 kms",
            name: " IGI Airport"
          },
          school: {
            distance_time: "2.8 Kms",
            name: " Vega School"
          },
          railwayormetro: {
            distance_time: "3 Kms",
            name: " Sec-55 Metro"
          },
          hospital: {
            distance_time: "4.3 Kms",
            name: "  Saksham Care"
          },
          mall: {
            distance_time: "3.7 Kms",
            name: " Entertainland Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_privana_west },
        { image: g2_privana_west },
        { image: g3_privana_west },
        { image: g4_privana_west },
        { image: g5_privana_west },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in DLF Privana West, kindly share more details.",
    },

    faq: [
      {
        question: "What are the key amenities at DLF Privana West?",
        answer: `The project includes a clubhouse, swimming pool, gymnasium, landscaped gardens, jogging tracks, children's play areas, and 24/7 security.`,
      },
      {
        question: "Where is DLF Privana West located?",
        answer: `The project is strategically located in Sector 76, gurugram, near major highways, commercial hubs, and social infrastructure.`,
      },
      {
        question: "What types of residences are available at DLF Privana West?",
        answer: `DLF Privana West offers premium 4 BHK residences designed with spacious layouts and high-end specifications.`,
      },
      {
        question: "What makes DLF Privana West a standout choice for homebuyers?",
        answer: `DLF Privana West in Sector 76, gurugram, is a standout choice for homebuyers due to its premium design, prime location, and world-class amenities. `,
      },
      {
        question: "What is the starting price of apartments in DLF Privana West?",
        answer: `The pricing details are available on request and may vary based on the unit size and configurations.`,
      },
      {
        question: "Is DLF Privana West RERA approved?",
        answer: `Yes, the project is RERA-registered, ensuring transparency and compliance with real estate regulations.`,
      },
      {
        question: "What is the total area of the project?",
        answer: `DLF Privana West spans a vast area, offering a well-planned layout with ample open spaces and green surroundings.`,
      },
      {
        question: "How well is DLF Privana West connected to major locations?",
        answer: `The project enjoys excellent connectivity to NH-48, Golf Course Extension Road, IGI Airport, and major business hubs in gurugram.`,
      },
      {
        question: "Are there any schools and hospitals near DLF Privana West?",
        answer: `Yes, reputed schools like DPS and hospitals like Medanta and Artemis are in close proximity to the project.`,
      },
      {
        question: "What makes DLF Privana West a premium investment option?",
        answer: `The project offers luxury living with superior design, strategic location, and the trusted brand value of DLF, making it an excellent investment.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "DLF - Privana west",
          image: dlfprivanawest,
          price: " 7.5 Cr",
          location: "Sector 76, Gurugram",
          state: "Gurugram",
          projectlocation: "Southern Peripheral Road",
          developer: "DLF",
          bed: "4 BHK",
          size: "3577 sq.ft",
          url: `/dlf-privana-west-sector-76-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - Privana west", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - Privana South",
          image: dlfprivanasouth,
          price: " 7.5 Cr",
          location: "Sector 77, Gurugram",
          developer: "DLF",
          projectlocation: "Central Peripheral Road",
          state: "Gurugram",
          bed: "4 BHK",
          size: "2150 sq. ft.",
          url: `/dlf-privana-south-sector-77-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - Privana South", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - Dahlias",
          image: dahilas,
          price: "On Request",
          location: "Sector 54, Gurugram",
          state: "Gurugram",
          projectlocation: "Golf Course Road",
          developer: "DLF",

          bed: "4 - 5 BHK",
          size: "....",
          url: `/dlf-dahlias-sector-54-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - Dahlias", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - The Arbour",
          image: thearbour,
          price: " 8.17 Cr",
          location: "Sector 63, Gurugram",
          developer: "DLF",
          projectlocation: "Golf Course Extension Road",
          state: "Gurugram",
          bed: " 4 BHK",
          size: "3800 sq. ft.",
          url: `/dlf-arbour-sector-63-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - The Arbour", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - Andheri",
          image: andheri,
          price: "On Request",
          developer: "DLF",
          location: "Andheri West",
          projectlocation: "Andheri West",
          state: "Mumbai",
          bed: "2 - 4 BHK",
          size: "On Request",
          url: ``,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  dlfdahlias: {
    bannerdata_dlfdahlias: {
      bannerDesktopImage: bannerDesktopImage_dahlias,
      bannerMobileImage: bannerMobileImage_dahlias,
      textOverlay: "",
      data: {
        title: "DLF Dahlias",
        rerano: "GGM/872/604/2024/99",
        starting_price: "On Request",
        payment_plan: "CLP",
        status: "New Launch",
        subtitle: "Sector 54, Gurugram",
      },
    },
    overview_dlfdahlias: {
      heading: "Discover Luxury Living at DLF Dahlias",
      description: [
        `DLF The Dahlias Sector 54 Golf Course Road gurugram represent gurugram's luxurious living. This property in Sector 54 on Golf 
       Course Road shows DLF's dedication to exceptional living experiences. The Dahlias, one of DLF's most significant debuts in recent years,
        will set new super-luxury real estate standards. DLF, India's largest publicly traded real estate developer, sees The Dahlias as more than 
        a project. They strategically included it in their high-end development portfolio. The Project has built a strong reputation in the premium 
        category, and this project shows their commitment. It joins other renowned DLF buildings, solidifying the company's premium real estate leadership.`,
      ],
      image: overviewImage_dahlias,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_dahlias,
          title: "On Request ",
          subtitle: "Starting price",
        },
        {
          iconClass: cal_dahlias,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_dahlias,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit_dlfdahlias: {
      image: siteVisitBannerImage_dahlias,
    },

    pricing_dlfdahlias: {
      heading: "Pricing",
      table: [
        {
          type: "4 BHK",
          area: "On Request",
          price: "On Request",
        },
        {
          type: "5 BHK",
          area: "On Request",
          price: "On Request",
        },
      ],
    },

    floor_plan_dlfdahlias: [
      {
        type: "4 BHK",
        area: "On Request",
        price: "On Request",
        image: image1BHK_dahlias,
      },
      {
        type: "5 BHK",
        area: "On Request",
        price: "On Request",
        image: image2BHK_dahlias,
      },
    ],

    highlights_dlfdahlias: {
      images: Hightlights_dahlias,
      tagline: "Highlights",
      features: [
        "Prime Location: Sector 54, gurugram, adjacent to Golf Course Road.",
        "Expansive Land Area: 17 acres of crown land.",
        "Ultra-Luxury Apartments: Sizes from 9,500 to 16,000 sq. ft.",
        "Skyline Towers: 29 premium floors with exclusive residences.",
      ],
    },

    location_dlfdahlias: {
      image: Location_dahlias,
      data: [
        {
          airport: {
            distance_time: "19.2 kms",
            name: " IGI Airport"
          },
          school: {
            distance_time: "0.7 Kms",
            name: "Suncity School"
          },
          railwayormetro: {
            distance_time: "1.7 Kms",
            name: "Sec-55 Metro"
          },
          hospital: {
            distance_time: "2 Kms",
            name: " Miracles clinic"
          },
          mall: {
            distance_time: "0.4 Kms",
            name: "Suncity Shopping Complex"
          }
        }
      ]
    },

    gallery_dlfdahlias: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_dahlias },
        { image: g2_dahlias },
        { image: g3_dahlias },
        { image: g4_dahlias },
        { image: g5_dahlias },
      ],
    },

    whatsapp_dlfdahlias: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in DLF Dahlias, kindly share more details.",
    },

    faq_dlfdahlias: [
      {
        question: "What makes DLF Dahlias a standout choice for homebuyers?",
        answer: `DLF Dahlias in Sector 54, gurugram, is a standout choice for homebuyers seeking ultra-luxurious living in one of the city's most prestigious locations.`,
      },
      {
        question: "Where is DLF Dahlias located?",
        answer: `The project is strategically situated in Sector 54, gurugram, along Golf Course Road, providing excellent connectivity to major areas.`,
      },
      {
        question: "What types of residences are available at DLF Dahlias?",
        answer: `DLF Dahlias offers spacious and well-designed 4 BHK residences with top-notch features and specifications.`,
      },
      {
        question: "What are the key amenities at DLF Dahlias?",
        answer: `The project features a clubhouse, swimming pool, gym, landscaped gardens, jogging tracks, children’s play area, and high-level security.`,
      },
      {
        question: "What is the starting price of apartments in DLF Dahlias?",
        answer: `The pricing details vary based on unit size and market trends, it is recommended to check with the developer for the latest price.`,
      },
      {
        question: "Is DLF Dahlias RERA approved?",
        answer: `Yes, the project is RERA-registered, ensuring transparency and adherence to real estate regulations.`,
      },
      {
        question: "How well is DLF Dahlias connected to major locations?",
        answer: `The project is well-connected to Golf Course Road, Rapid Metro, MG Road, Cyber City, and IGI Airport.`,
      },
      {
        question: "Are there any reputed schools and hospitals near DLF Dahlias?",
        answer: `Yes, renowned schools like The Shri Ram School and hospitals like Fortis and Medanta are in close proximity.`,
      },
      {
        question: "What makes DLF Dahlias a premium investment option?",
        answer: `The project offers high-end living with premium specifications, a prime location, and the brand value of DLF, making it a valuable investment. `,
      },
      {
        question: "What is the expected possession date of DLF Dahlias??",
        answer: `The possession timeline may vary; checking with the developer for updates is advisable.`,
      },
    ],
    similar_dlfdahlias: {
      properties: [
        {
          name: "DLF - Privana west",
          image: dlfprivanawest,
          price: " 7.5 Cr",
          location: "Sector 76, Gurugram",
          state: "Gurugram",
          projectlocation: "Southern Peripheral Road",
          developer: "DLF",
          bed: "4 BHK",
          size: "3577 sq.ft",
          url: `/dlf-privana-west-sector-76-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - Privana west", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - Privana South",
          image: dlfprivanasouth,
          price: " 7.5 Cr",
          location: "Sector 77, Gurugram",
          developer: "DLF",
          projectlocation: "Central Peripheral Road",
          state: "Gurugram",
          bed: "4 BHK",
          size: "2150 sq. ft.",
          url: `/dlf-privana-south-sector-77-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - Privana South", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - Dahlias",
          image: dahilas,
          price: "On Request",
          location: "Sector 54, Gurugram",
          state: "Gurugram",
          projectlocation: "Golf Course Road",
          developer: "DLF",

          bed: "4 - 5 BHK",
          size: "....",
          url: `/dlf-dahlias-sector-54-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - Dahlias", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - The Arbour",
          image: thearbour,
          price: " 8.17 Cr",
          location: "Sector 63, Gurugram",
          developer: "DLF",
          projectlocation: "Golf Course Extension Road",
          state: "Gurugram",
          bed: " 4 BHK",
          size: "3800 sq. ft.",
          url: `/dlf-arbour-sector-63-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - The Arbour", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - Andheri",
          image: andheri,
          price: "On Request",
          developer: "DLF",
          location: "Andheri West",
          projectlocation: "Andheri West",
          state: "Mumbai",
          bed: "2 - 4 BHK",
          size: "On Request",
          url: ``,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },

  dlfthearbour: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_the_arbour,
      bannerMobileImage: bannerMobileImage_the_arbour,
      textOverlay: "",
      data: {
        title: "DLF The Arbour",
        rerano: "GGM/671/403/2023/15",
        starting_price: " 8.17 Cr",
        payment_plan: "CLP",
        status: "Under Construction",
        subtitle: "Sector 63, Gurugram",
      },
    },
    overview: {
      heading: "Discover Luxury Living at DLF The Arbour",
      description: [
        `DLF The Arbour Sector 63 gurugram will be your new era of luxurious living with the benefit of a less crowded residential society 
       where you can enjoy the serenity of the beautiful location of this residential community.
       The project is now in the pre-launch phase with exclusive offers for the early buyers only for a limited time only.
        Grab this opportunity to be among the first to enjoy the luxuriousness of greenery with beautiful parks and gardens
         within and around the residential society of DLF Sector 63 gurugram. Every 4BHK luxury apartment has open view to enjoy 
         and will make you feel healthy every second. DLF has always maintained its
        reputation for providing high standard living experience.`,
      ],
      image: overviewImage_the_arbour,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_the_arbour,
          title: "₹ 8.17 Cr ",
          subtitle: "Starting price",
        },
        {
          iconClass: cal_the_arbour,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_the_arbour,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_the_arbour,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "4 BHK",
          area: "3800 sq. ft.",
          price: " 8.17 Cr",
        },
      ],
    },

    floor_plan: [
      {
        type: "4 BHK",
        area: "3800 sq. ft.",
        price: " 8.17 Cr",
        image: image1BHK_the_arbour,
      },
    ],

    highlights: {
      images: Hightlights_the_arbour,
      tagline: "Highlights",
      features: [
        "Spread over 25 acres of land.",
        "5 High rise towers with (Ground + 39 Floors).",
        "3 Level Basements Parking.",
        "Floor To Ceiling Heights is 3.4 Mtrs.",
      ],
    },

    location: {
      image: Location_the_arbour,
      data: [
        {
          airport: {
            distance_time: "24.1 kms",
            name: "IGI Airport"
          },
          school: {
            distance_time: "2.9 Kms",
            name: "Gurugram Public School"
          },
          railwayormetro: {
            distance_time: "6.1 Kms",
            name: "Sec-55 Metro"
          },
          hospital: {
            distance_time: "4.1 Kms",
            name: " Marengo Asia Hospital"
          },
          mall: {
            distance_time: "1.5 Kms",
            name: "Paras Trinity"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_the_arbour },
        { image: g2_the_arbour },
        { image: g3_the_arbour },
        { image: g4_the_arbour },
        { image: g5_the_arbour },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in DLF The Arbour, kindly share more details.",
    },

    faq: [
      {
        question: "What makes DLF The Arbour a standout choice for homebuyers?",
        answer: `DLF The Arbour in Sector 63, gurugram, stands out as a premium choice for homebuyers due to its unparalleled luxury, prime location, and world-class amenities.`,
      },
      {
        question: "Where is DLF The Arbour located?",
        answer: `The project is strategically located in Sector 63, gurugram, with excellent connectivity to Golf Course Extension Road and major business hubs.`,
      },
      {
        question: "What types of residences are available at DLF The Arbour?",
        answer: `The project offers spacious 4 BHK luxury apartments with high-end interiors and modern architectural design.`,
      },
      {
        question: "What are the key amenities at DLF The Arbour?",
        answer: `Amenities include a grand clubhouse, infinity pool, gymnasium, landscaped gardens, sports courts, jogging tracks, and 24/7 security.`,
      },
      {
        question: "What is the starting price of apartments in DLF The Arbour?",
        answer: `Prices vary based on unit specifications; for the latest pricing.`,
      },
      {
        question: "Is DLF The Arbour RERA approved?",
        answer: `Yes, the project is RERA-registered, ensuring transparency and compliance with real estate regulations.`,
      },
      {
        question: "What is the total area of the project?",
        answer: `DLF The Arbour spans a vast land area, offering a low-density living experience with ample green spaces and modern infrastructure.`,
      },
      {
        question: "How well is DLF The Arbour connected to key locations?",
        answer: `The project enjoys seamless connectivity to Golf Course Road, NH-48, Rapid Metro, IGI Airport, and Cyber City.`,
      },
      {
        question: "Are there reputed schools and hospitals near DLF The Arbour?",
        answer: `Yes, top schools like The Shri Ram School and hospitals like Medanta and Fortis are nearby, ensuring convenience for residents.`,
      },
      {
        question: "What makes DLF The Arbour a premium investment option?",
        answer: `The project offers high-end living with luxury specifications, a prime location, and the trusted legacy of DLF, making it a valuable investment.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "DLF - Privana west",
          image: dlfprivanawest,
          price: " 7.5 Cr",
          location: "Sector 76, Gurugram",
          state: "Gurugram",
          projectlocation: "Southern Peripheral Road",
          developer: "DLF",
          bed: "4 BHK",
          size: "3577 sq.ft",
          url: `/dlf-privana-west-sector-76-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - Privana west", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - Privana South",
          image: dlfprivanasouth,
          price: " 7.5 Cr",
          location: "Sector 77, Gurugram",
          developer: "DLF",
          projectlocation: "Central Peripheral Road",
          state: "Gurugram",
          bed: "4 BHK",
          size: "2150 sq. ft.",
          url: `/dlf-privana-south-sector-77-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - Privana South", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - Dahlias",
          image: dahilas,
          price: "On Request",
          location: "Sector 54, Gurugram",
          state: "Gurugram",
          projectlocation: "Golf Course Road",
          developer: "DLF",

          bed: "4 - 5 BHK",
          size: "....",
          url: `/dlf-dahlias-sector-54-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - Dahlias", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - The Arbour",
          image: thearbour,
          price: " 8.17 Cr",
          location: "Sector 63, Gurugram",
          developer: "DLF",
          projectlocation: "Golf Course Extension Road",
          state: "Gurugram",
          bed: " 4 BHK",
          size: "3800 sq. ft.",
          url: `/dlf-arbour-sector-63-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "DLF - The Arbour", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "DLF - Andheri",
          image: andheri,
          price: "On Request",
          developer: "DLF",
          location: "Andheri West",
          projectlocation: "Andheri West",
          state: "Mumbai",
          bed: "2 - 4 BHK",
          size: "On Request",
          url: ``,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  privananorth: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprivananorth,
      bannerMobileImage: bannerMobileImageprivananorth,
      textOverlay: "",
      data: {
        title: "Discover Luxury Living at DLF Privana North",
        subtitle: " Sector 77, Gurugram",
        starting_price: "₹ 7.5 Cr Crore Onwards  ",
        payment_plan: "CLP",
        rerano: "-",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Discover Luxury Living at DLF Privana North",
      description: [
        "DLF Privana North in Sector 76, Gurgaon is a premium residential project by DLF, one of India’s most trusted real estate developers. Strategically located near NH-48 and Dwarka Expressway, it offers excellent connectivity to major business hubs, schools, hospitals, and shopping centers. DLF Privana North features spacious 3 and 4 BHK apartments designed for modern urban living. With lush green landscapes, world-class amenities, and a secure gated community, residents enjoy both comfort and peace of mind. Highlights include a clubhouse, swimming pool, gym, kids’ play area, and more. The project focuses on sustainability with eco-friendly features and efficient layouts. Whether you're buying a home for your family or investing in property, DLF Privana North in Sector 76 Gurgaon offers great value and future appreciation potential. Experience luxury living in a well-planned neighborhood with everything you need close by.",
       ],
      keywordLinks: {
      },
      image: overviewImageprivananorth,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprivananorth,
          title: "₹ 7.5 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprivananorth,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprivananorth,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "4 BHK  ",
          area: "3000 sq.ft. ",
          price: "₹ 7.5 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "4 BHK  ",
        area: "3000 sq.ft. ",
        price: "₹ 7.5 Cr",
        image: floorplan2privananorth,
      }
    ],

    highlights: {
      images: Hightlightsprivananorth,
      tagline: "Highlights",
      features: [
        "5 Towers, 63 units per acre ",
        "80% Open Space ",
        "3 Car Parks - Typical Units ",
        "View of the Aravalli Hills ",
      ],
    },

    location: {
      image: Locationprivananorth,
      data: [
        {
          airport: {
            distance_time: "29.9 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "5.3 Km",
            name: "Vega School"
          },
          railwayormetro: {
            distance_time: "17.2 Km",
            name: "Garhi Junction"
          },
          hospital: {
            distance_time: "2 Km",
            name: "MET Hospital"
          },
          mall: {
            distance_time: "3.3 Km",
            name: "Entertainland Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1privananorth },
        { image: gallery2privananorth },
        { image: gallery3privananorth },
        { image: gallery4privananorth },
        { image: gallery5privananorth },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in DLF Privana North, kindly share more details.",
    },

    faq: [
      {
        question: "What makes DLF Privana North a standout choice for homebuyers?",
        answer: `DLF Privana North in Sector 76, gurugram, stands out as a premium choice for homebuyers due to its unparalleled luxury, prime location, and world-class amenities.`,
      },
      {
        question: "Where is DLF Privana North located?",
        answer: `The project is strategically located in Sector 76, gurugram, with excellent connectivity to Golf Course Extension Road and major business hubs.`,
      },
      {
        question: "What types of residences are available at DLF Privana North?",
        answer: `The project offers spacious 3 BHK and 4 BHK luxury apartments with high-end interiors and modern architectural design.`,
      },
      {
        question: "What are the key amenities at DLF Privana North?",
        answer: `Amenities include a grand clubhouse, infinity pool, gymnasium, landscaped gardens, sports courts, jogging tracks, and 24/7 security.`,
      },
      {
        question: "What is the starting price of apartments in DLF Privana North?",
        answer: `Prices vary based on unit specifications; for the latest pricing.`,
      },
      {
        question: "Is DLF Privana North RERA approved?",
        answer: `Yes, the project is RERA-registered, ensuring transparency and compliance with real estate regulations.`,
      },
      {
        question: "What is the total area of the project?",
        answer: `DLF Privana North spans a vast land area, offering a low-density living experience with ample green spaces and modern infrastructure.`,
      },
      {
        question: "How well is DLF Privana North connected to key locations?",
        answer: `The project enjoys seamless connectivity to Golf Course Road, NH-48, Rapid Metro, IGI Airport, and Cyber City.`,
      },
      {
        question: "Are there reputed schools and hospitals near DLF Privana North?",
        answer: `Yes, top schools like Vega School and hospitals like MET Hospital are nearby, ensuring convenience for residents.`,
      },
      {
        question: "What makes DLF Privana North a premium investment option?",
        answer: `The project offers high-end living with luxury specifications, a prime location, and the trusted legacy of DLF, making it a valuable investment.`,
      },
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },

};
